import { WixProGalleryBase } from './gallery';
import { WixProGalleryWithFullscreen } from './withFullscreen';
import { WixProGalleryWithItemProcessing } from './withItems';
import { WixProGalleryWithFlattenOptions } from './withOptions';
import { WixProGalleryWithLayoutFixer } from './withLayoutFixer';
import { WixProGalleryWithStructure } from './withStructure';
import { WixProGalleryWithCustomInfo } from './withCustomInfo';
import { WixProGalleryWithCustomImageRenderer } from './withCustomImageRenderer';
import { WixProGalleryWithAccessability } from './withAccessibility';
import { WixProGalleryStylableOverlayAnimations } from './withStylableOverlayAnimations';
import { withFirstInteractionHook } from './withFirstInteractionHook';
import { WithNoScript } from './withNoScript';
const WixProGallery = WixProGalleryWithItemProcessing(WixProGalleryWithAccessability(WixProGalleryWithFlattenOptions(withFirstInteractionHook(WixProGalleryWithCustomImageRenderer(WixProGalleryWithCustomInfo(WixProGalleryStylableOverlayAnimations(WixProGalleryWithStructure(WixProGalleryWithLayoutFixer(WithNoScript(WixProGalleryWithFullscreen(WixProGalleryBase)))))))))));
const addModule = {
  fullScreen: WixProGalleryWithFullscreen,
  itemProcessing: WixProGalleryWithItemProcessing,
  flattenOptions: WixProGalleryWithFlattenOptions,
  layoutFixer: WixProGalleryWithLayoutFixer,
  structure: WixProGalleryWithStructure,
  customInfo: WixProGalleryWithCustomInfo,
  stylableOverlayAnimations: WixProGalleryStylableOverlayAnimations
};
export { WixProGalleryBase, WixProGallery, addModule };
//# sourceMappingURL=index.js.map